import styled from 'styled-components';

export const ContractContainer = styled.div`
background: #F0FFE6;
width: 100%;
height: 100%;
position: relative;
`;

export const ContractWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 50px 25px;
`;

export const ContractElement = styled.div`
position: relative;
background: #fff;
border-radius: 10px;
box-shadow: 5px 5px rgba(136, 136, 136, 0.1);
width: 100%;
margin-bottom : 25px;
padding: 15px;
`;

export const ElementHeader = styled.h3`
font-size: 18px;
color: #000;
padding: 10px 20px;
`;

export const ElementDesc = styled.p`
font-size: 16px;
color: #000;
padding: 10px 20px;
`;

export const ContractHeader = styled.h3`
font-size: 24px;
color: #000;
padding: 10px 20px;
`;

export const ContractWalletText = styled.p`
font-size: 18px;
font-weight: 500;
color: #000;
padding: 10px 20px;

@media screen and (max-width: 768px) {
    font-size: 14px;
}
`;

export const ElementInput = styled.input`
border: none;
border-bottom: 2px solid #D3D3D3;
height: 30px;
width: 425px;
padding-left: 5px;
transition: all 0.2s ease-in-out;
margin-bottom: ${({ bottom }) => (bottom)};

&:focus {
    outline: none;
    border-bottom: 2px solid #33682c;
}

@media screen and (max-width: 768px){
    width: 325px;
}

@media screen and (max-width: 480px){
    width: 275px;
}
`;

export const ContractForm = styled.form`
display: flex;
flex-direction: column;
padding: 10px 20px;
`;
